module.exports = __webpack_public_path__ + "media/images/graph-3-eac4768dddbcde685a8badf5a55f1258.svg";